module.exports = __webpack_public_path__ + "static/background-2-91e2adedafae6469c9ad6ef96538bd36.jpg";